import React, { useState } from "react";
import { Form, Input } from "antd";
import { CompanyCodeGenerator } from "../../../common/userfuctions";
import { InfoCircleOutlined } from "@ant-design/icons";


export const OnChangeInputFields = (type, form, item) => {
  switch (type) {
    case 'CompanyCode': return (e) => form.setFieldsValue({ [item?.OnChangeParams?.ObjectId]: CompanyCodeGenerator(e.target.value) })
  }
}

export const OnBlurInputFields = (type, form, item) => {

  let Message = "";
  let Status = "success";
  let ShowFeedback = true;

  switch (type) {
    case 'ValidateCompany': return (value) => {
      return { Status, Message, ShowFeedback }
    }
  }
}


const UIFromTextInput = ({
  label,
  name,
  required,
  rules,
  onChange,
  onBlur,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  defaultValue,
  placeholder = "",
  tooltip,
  style = {},
  source,
  compact = false,
}) => {
  const [vStatus, setVStatus] = useState(validateStatus)
  const [fHelp, setfHelp] = useState(help)
  const [hFeedback, sethFeedback] = useState(hasFeedback)

  const inputStyle = {
    color: disabled ? "#666" : "",
    padding: compact ? "8px 12px" : "12px 10px",
    fontSize: compact ? "14px" : (disabled ? '14px' : '16px'),
    fontWeight: "500",
    height: compact ? 42 : undefined,
    borderRadius: compact ? 22 : undefined,
    width: "100%",
    border: compact ? "1px solid #e5e7eb" : undefined,
    boxShadow: compact ? "0 8px 22px rgba(15, 23, 42, 0.04)" : undefined,
    ...style
  }

  const empInputStyle = {
    padding: "12px",
    fontWeight: "500",
    border: "1px solid #e5e7eb",
    borderRadius: 22,
    height: 42,
    display: "flex",
    alignItems: "center",
    boxShadow: "0 12px 35px rgba(15, 23, 42, 0.04)",
    ...style
  }

  return (
    <>
      <Form.Item
        label={
          <span style={{ fontSize: compact ? "14px" : "16px", fontWeight: "500" }}>{label}</span>
        }
        name={name}
        required={required}
        rules={rules}
        hasFeedback={hFeedback}
        help={fHelp}
        validateStatus={vStatus}
        initialValue={defaultValue}
        tooltip={tooltip && {
          title: tooltip,
          icon: <InfoCircleOutlined />,
        }}

      >
        <Input
          onChange={(value) => {
            onChange && onChange(value)
          }}
          onBlur={(e) => {
            if (onBlur) {
              const value = e.target.value
              const result = onBlur && onBlur(value)
              setVStatus(result?.Status);
              setfHelp(result?.Message);
              sethFeedback(result?.ShowFeedback)
            }
          }}
          disabled={disabled}
          placeholder={placeholder}
          // defaultValue={defaultValue}
          // style={style}
          style={source == "employer" ? empInputStyle : inputStyle}
        />
      </Form.Item>
    </>
  );
};

export default UIFromTextInput;
